import React from 'react';
import AgingReportPage from './AgingReportPage';

export default function APAgingReportPage() {
  return <AgingReportPage variant="ap" />;
}
